module.exports = __webpack_public_path__ + "assets/img/kv-2389ed2d.jpg";